import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { makeStyles, Typography } from '@material-ui/core';

import { CheckoutForm } from './CheckoutForm';
import { submitPayment } from '@api';

const useStyles = makeStyles(() => ({
  creditCardLabel: {
    marginBottom: '25px',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '20px',
    letterSpacing: '-0.08px',
  },
}));

export const PaymentMethodElement = ({
  stripe,
  paymentConfig,
  amount,
  customer,
  type,
  onSuccess,
  onProccess,
  onCancel,
  onError,
  orderId = '',
  reset,
}) => {
  const classes = useStyles();
  const { market, currency, merchantAccount, channel } = paymentConfig;
  const elementFonts = [
    {
      family:
        'GTAmerica,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Roboto,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji',
    },
  ];
  const elementAppearance = {
    theme: 'none',
    variables: {
      colorBackground: '#ffffff',
      colorText: '#1B1B1B',
      colorTextSecondary: '#000000',
      colorPrimary: '#000000',
      fontFamily:
        'GTAmerica, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Roboto, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
      fontWeightLight: '300',
      fontWeightNormal: '400',
      fontWeightMedium: '500',
      fontWeightBold: '500',
      spacingUnit: 2,
      spacingGridRow: '20px',
      spacingGridColumn: '10px',
    },
    rules: {
      '.Error': {
        fontFamily:
          'GTAmerica, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Roboto, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
        fontWeight: 300,
        fontSize: '16px',
        lineHeight: '1.5',
        letterSpacing: '-0.6px',
        color: '#E04732',
        marginTop: '8px',
      },

      '.Label': {
        color: 'var(--Grayscale-Nero, #1B1B1B)',
        fontFamily: 'GTAmerica, sans-serif',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '16px',
        letterSpacing: '1.16px',
        textTransform: 'uppercase',
        fontStretch: 'condensed',
      },

      '.Input': {
        borderRadius: 0,
        fontFamily:
          'GTAmerica, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Roboto, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.6px',
        color: '#1B1B1B',
        padding: '16px 20px',
        border: '1px solid #d2cdc1',
        boxShadow: 'none',
      },

      '.Input--invalid': {
        borderRadius: 0,
        fontFamily:
          'GTAmerica, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Roboto, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.6px',
        color: '#1B1B1B',
        padding: '16px 20px',
        border: '1px solid #E04732',
        boxShadow: 'none',
      },

      '.Input:focus': {
        outline: '#C2B299 solid 2px',
        outlineOffset: '0px',
      },

      '.PickerItem': {
        fontSize: '12px',
        padding: '0px',
        border: '0',
        borderRadius: '0',
        boxShadow: 'none',
      },
    },
  };

  const paymentRequest = {
    totalAmount: amount,
    currency: currency,
    market: market,
    statementDescriptor: 'Lucid sales-online',
    merchantAccount: merchantAccount,
    paymentMethodType: type,
    channel: channel,
    testMode: 'true',
    customer: {
      firstName: customer.firstName,
      lastName: customer.lastName,
      phoneNumber: customer.phoneNumber,
      email: customer.email,
      language: customer.language,
      country: customer.country,
      billingAddress: customer.primaryBilling,
      shippingAddress: customer.primaryShipping,
    },
    metadata: {},
    locale: customer.locale,
  };
  const [clientSecret, setClientSecret] = useState(null);
  useEffect(() => {
    if (!merchantAccount) return;
    console.log('paymentRequest');
    submitPayment(paymentRequest).then(submitted =>
      setClientSecret(submitted.clientSecret)
    );
  }, [reset]);

  return (
    <>
      {clientSecret && (
        <>
          <Typography variant="h6" className={classes.creditCardLabel}>
            Enter credit card information
          </Typography>
          <Elements
            stripe={stripe}
            options={{
              clientSecret: clientSecret,
              appearance: elementAppearance,
              fonts: elementFonts,
              locale: market,
            }}
          >
            <CheckoutForm
              clientSecret={clientSecret}
              onSuccess={onSuccess}
              onProccess={onProccess}
              onCancel={onCancel}
              onError={onError}
              orderId={orderId}
              customer={customer}
            />
          </Elements>
        </>
      )}
    </>
  );
};
